import { SxStyle } from '@aibees/shared/theme';

const flexCenter = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
};

const borderStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
};

export const select: SxStyle = {
  minWidth: (p) => p.spacing(24),
  maxHeight: (p) => p.spacing(4.5),
  background: (p) => p.palette.common.white,
  ...borderStyle,
  borderColor: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(0.5),

  '& .MuiSelect-select': {
    pl: (p) => p.spacing(2),
    fontWeight: 600,
    fontSize: (p) => p.typography.caption.fontSize,
    color: (p) => p.palette.common.black,
  },
};

export const menu: SxStyle = {
  ...borderStyle,
  // borderColor: (p) => p.palette.primary[500],
  mt: (p) => p.spacing(1),
  p: 0,

  // '& .Mui-selected': {
  //   background: (p) => `${p.palette.primary[500]} !important`,
  //   color: (p) => `${p.palette.common.white} !important`,
  // },

  // '& .Mui-selected:hover ': {
  //   background: (p) => `${p.palette.primary[500]} !important`,
  // },

  // '& .MuiMenuItem-root:hover': {
  //   background: (p) => `${p.palette.primary[50]} `,
  // },
};

export const menuItem: SxStyle = {
  ...flexCenter,
  fontSize: (p) => p.typography.caption,
  borderBottom: (p) => ` 1px solid ${p.palette.grey[300]}`,
  p: (p) => p.spacing(1),
  borderRadius: 0,
};

export const item: SxStyle = {
  ...flexCenter,
};

export const contactIcon: SxStyle = {
  color: (p) => p.palette.success[500],
};

export const companyIcon: SxStyle = {
  color: (p) => p.palette.primary[500],
};
